import React, { useState } from 'react'
import { Button } from 'primereact/button'
import _ from 'lodash'
import { getMessage } from '../../../utils/index'
import { validarCriterioRemessa } from '../../../services/api-crud-integracao'
import { AJUDA_EMBRULHO, AJUDA_EXEMPLO, validarTextoCriterio } from '../criterioRemessa'

/**
 * Botão "Validar critério" da Remessa Financeira (PHOENIX-943, §6.4).
 *
 * As checagens locais são conveniência — quem garante é o backend, que roda EXPLAIN e conta os
 * contratos. O número devolvido é o que revela erro semântico: critério que compila mas seleciona
 * o conjunto errado.
 */
export default function ValidarCriterioRemessa({ oidUnidade, consultaSql, messages }) {
  const [validando, setValidando] = useState(false)
  const [resultado, setResultado] = useState(null)

  // getMessage devolve '' quando o código ainda não existe no dicionário da empresa, então cada
  // rótulo tem texto de reserva — a tela não pode ficar com botão sem nome esperando a migration.
  const label = (chave, reserva) => getMessage(messages, `crudIntegracao.label.${chave}`) || reserva

  const validar = () => {
    if (!oidUnidade) {
      setResultado({ valido: false, mensagem: 'Selecione a unidade antes de validar o critério' })
      return
    }
    const erroLocal = validarTextoCriterio(consultaSql)
    if (erroLocal) {
      setResultado({ valido: false, mensagem: erroLocal })
      return
    }

    setValidando(true)
    setResultado(null)
    validarCriterioRemessa(oidUnidade, consultaSql)
      .then((response) => setResultado(_.get(response, 'data', null)))
      .catch((error) =>
        setResultado({
          valido: false,
          mensagem: _.get(error, 'response.data', 'Não foi possível validar o critério'),
        })
      )
      .finally(() => setValidando(false))
  }

  const resolveMensagem = () => {
    if (!resultado) {
      return null
    }
    const cor = resultado.valido ? '#2f855a' : '#c53030'
    return <div style={{ marginTop: '10px', color: cor, whiteSpace: 'pre-wrap' }}>{resultado.mensagem}</div>
  }

  return (
    <div style={{ marginTop: '15px' }}>
      <Button
        label={validando ? label('validandoCriterio', 'Validando...') : label('validarCriterio', 'Validar critério')}
        icon="pi pi-check-circle"
        onClick={validar}
        disabled={validando}
        type="button"
      />
      {resolveMensagem()}
      {/* Painel delimitado de propósito: solto na página, o texto de ajuda se confunde com os
          campos que vierem depois dele. */}
      <div
        style={{
          marginTop: '15px',
          padding: '10px 12px',
          fontSize: '0.85em',
          opacity: 0.85,
          border: '1px solid rgba(128, 128, 128, 0.3)',
          borderRadius: '4px',
        }}
      >
        <div>
          {label(
            'ajudaCriterio',
            'O campo acima guarda apenas a condição sobre o contrato. O sistema monta a consulta:'
          )}
        </div>
        <pre style={{ margin: '5px 0', overflowX: 'auto' }}>{AJUDA_EMBRULHO}</pre>
        <div>
          Placeholders disponíveis: <code>{'{{oid_empresa}}'}</code>, <code>{'{{oid_unidade}}'}</code>,
          <code>{'{{competencia}}'}</code> e <code>{'{{vencimento}}'}</code>. Exemplo — contratos que ainda não foram
          faturados:
        </div>
        <pre style={{ margin: '5px 0', overflowX: 'auto' }}>{AJUDA_EXEMPLO}</pre>
      </div>
    </div>
  )
}
